import AFSLogo from '@/assets/branding/afs/AITF-LOGO.png';

export default {
  name: 'Assistiv',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AFSLogo,
  colors: {
    // Brand colors
    brand_primary: '#8FC542',
    brand_primary_hover: '#6FA336',
    brand_primary_highlight: '#C8E59A',
    brand_primary_mid: '#A4D363',
    brand_primary_dark: '#456122',
    brand_secondary: '#5F7D2B',
  },
};
